import { useCallback } from 'react';
import { useAccount } from 'wagmi';
import { parseUnits } from 'ethers';
import useSend from 'hooks/useSend';
import { UserMission } from 'gql-ops/graph/__generated__/request';

interface UseMintNFTProps {
    contract: any;
    onSuccess?: (mission: UserMission) => void;
}

export default function useMintNFT({ contract, onSuccess }: UseMintNFTProps) {
    const { address } = useAccount();
    const send = useSend();

    const mint = useCallback(
        async (mission: UserMission) => {
            if (!address) {
                return;
            }

            try {
                if (!contract) {
                    return;
                }

                const hasMinted = await contract.hasMinted(address);
                if (hasMinted) {
                    return;
                }

                await send({
                    contract,
                    method: 'mint',
                    params: [],
                    pendingText: 'Minting NFT...',
                    summary: 'Mint NFT',
                    showSuccess: false,
                    sendParams: {
                        value: '0',
                    },
                    customMaxFeePerGas: parseUnits('0.005000007', 'gwei'),
                    customMaxPriorityFeePerGas: parseUnits('0.005', 'gwei'),
                    onSuccess: async ({ hash, res }) => {
                        const balance = await contract.balanceOf(address);
                        if (balance > 0) {
                            try {
                                onSuccess?.(mission);
                            } catch (error) {
                                console.error('Failed to start mission:', error);
                            }
                        }
                    },
                    onError: (error) => {
                        console.error('Failed to mint NFT:', error);
                    },
                });
            } catch (error: any) {
                console.error('Failed to mint NFT:', error);
            }
        },
        [address, contract, send, onSuccess],
    );

    return { mint };
}
